import {IUser} from '@/interfaces/user';
import RolesRepository from '@/repositories/RolesRepository';
import {Options, Vue} from 'vue-class-component';
import {IRole} from '@/models/role.model';
import {validate} from '@/utils/permission-validate';
import {useToast} from 'vue-toastification';
import {AxiosResponse} from 'axios';

@Options({
    name: 'roles-list',
    mounted() {
        this.getResults();
    }
})
export default class RolesList extends Vue {
    public roles: any[] = [];
    applicationId: string = '';
    loading: boolean = false;
    page = 1;
    records = 0;
    perPage = 10;
    criteria: string = '';
    optionFilter: number = 1;
    optionsStatusFilter: any[] = [
        {
            name: 'Activos',
            value: 1
        },
        {
            name: 'Inactivos',
            value: 0
        }
    ];
    optionPerPage: number[] = [5, 10, 15, 20];
    optionsPaginate = {
        texts: {
            count: `Mostrando {from} a {to} de {count} registros | {count} registros | Un registro`
        }
    };
    private toast = useToast();

    get user(): IUser {
        return this.$store.getters.user;
    }
    get applicationCode(): string {
        return this.$store.getters.applicationCode;
    }

    async getResults() {
        this.loading = true;
        await RolesRepository.getPaginated(
            this.page,
            this.perPage,
            Boolean(this.optionFilter),
            this.criteria ? this.criteria : ''
        )
            .then((response: AxiosResponse) => {
                const {data} = response;
                this.roles = data.data;
                this.records = data.total;
            })
            .catch((error: AxiosResponse) => {
                const {status} = error;

                if (status === 500)
                        this.toast.error('Error interno en el servidor');

                if (!status) {
                    this.toast.error(`${error}`);
                    return;
                }
            })
            .finally(() => (this.loading = false));
    }

    async editRole(role: IRole) {
        this.$router.push({
            name: 'roles-edit',
            params: {
                role: role.id,
                name: role.name
            }
        });
    }

    async changeRoleStatus(roleId: number, status: boolean) {
        try {
            this.loading = true;
            const data = {
                status: !status
            };
            await RolesRepository.changeRoleStatus(roleId, data)
                .then(() => {
                    this.toast.success(
                        `Rol ${status ? 'eliminado' : 'activado'} con éxito.`
                    );
                })
                .catch((error: AxiosResponse) => {
                    const {status} = error;
                    if (!status) {
                        this.toast.error(`${error}`);
                        return;
                    }
                    this.toast.error(
                        `Ocurrió un error, por favor intente nuevamente.`
                    );
                })
                .finally(async () => {
                    await this.getResults();
                });
        } catch (error) {
            console.log('error :>> ', error);
        }
    }

    async cleanCliteria() {
        this.criteria = '';
        await this.filterStatusApp();
    }

    async filterStatusApp() {
        this.loading = true;
        this.page !== 1 ? (this.page = 1) : '';
        await this.getResults();
    }

    async rowsPerPage() {
        this.loading = true;
        this.page !== 1 ? (this.page = 1) : '';
        await this.getResults();
    }

    goToCreateRole() {
        this.$router.push({name: 'roles-create'});
    }

    isValidPermission(permission: string) {
        return validate(permission);
    }
}
